import {Tag, TagCategory} from "../gen/api";
import {useEffect, useState} from "react";

export function useAreasOfApplication(tagCategories: TagCategory[] | undefined): TagCategory | undefined {
  const [areasOfApplication, setAreasOfApplication] = useState<TagCategory>();

  useEffect(() => {
    if (tagCategories) setAreasOfApplication(tagCategories.find(category => category.name === "Einsatzbereich"));
  }, [tagCategories]);

  return areasOfApplication;
}

export function useSelectedTagIds(tagCategories: TagCategory[] | undefined): string[] | undefined {
  const [tagIds, setTagIds] = useState<string[]>();

  useEffect(() => {
    if (tagCategories) setTagIds(tagCategories.flatMap(category => category.tags)
      .flatMap(parentTag => [parentTag, ...parentTag.childTags ?? []])
      .filter(tag => tag.selected)
      .map(tag => tag.id!));
  }, [tagCategories]);

  return tagIds;
}

export function getAllTags(tags: Tag[]): Tag[] {
  return tags.flatMap(tag =>
    tag.childTags && tag.childTags.length > 0 ? getAllTags(tag.childTags) : [tag]
  )
}

